import React, { useContext } from "react"
import { MovieContext } from "../Context/MovieContext"
import { Card, List} from "antd"
import { useHistory } from "react-router-dom"

const Movies = () => {
    const[listOfMovie] = useContext(MovieContext)
    let history = useHistory()


    const HandleDetail = async (event) => {
        let idMovie = Number(event.target.value)

        history.push(`/movies/${idMovie}/detail`)
    }
    return (
        <div style={{marginTop: "100px"}}>
            <List 
                pagination={{
                    pageSize: 9 
                  }}
                grid = {{ column: 3}}
                dataSource={listOfMovie}
                renderItem={el => (
               
                <List.Item>
                    <Card hoverable="true" key={el.id}>
                        <img src={el.image_url} alt="banner-game"></img>
                        <h1>{el.title}</h1>
                        <button className="button-7" onClick={HandleDetail} value={el.id} >Detail</button>
                    </Card>
                   
                </List.Item>
              
                )}
            />
        </div>
        
    )
}

export default Movies